module.exports = __webpack_public_path__ + "img/cpany8.f50babe3.png";